<template>
  <v-container id="stats" tag="section">
    <base-v-component heading="Historial de Pedidos" />
    <base-material-card
      color="indigo"
      icon="mdi-basket"
      inline
      class="px-5 py-3"
    >
      <!--       <v-toolbar flat color="white">
        <v-spacer />
      </v-toolbar> -->
      <v-dialog v-model="dialogoAlert" persistent max-width="480">
        <v-alert
          dense
          border="left"
          type="warning"
          class="mb-0"
          icon="mdi-alert"
          v-model="dialogoAlert"
          dismissible
          @input="dialogoAlert = false"
        >
          La fecha inicial <strong>no puede ser posterior</strong> a la fecha de
          fin.
          <br />
          Por favor elija
          <strong>una fecha final posterior al {{ fechaInicio }}</strong
          >.
        </v-alert>
      </v-dialog>
      <v-row class="mt-4 mb-2">
        <v-col cols="12" sm="6" lg="4" class="pb-0">
          <v-dialog
            ref="dialog"
            class="rounded-lg"
            v-model="dialogoCalendario"
            max-width="360px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                dense
                v-model="rangoFechas"
                label="Rango de fechas"
                append-icon="mdi-calendar"
                readonly
                outlined
                v-bind="attrs"
                v-on="on"
              ></v-text-field>
            </template>
            <v-card>
              <v-card-text class="pb-0">
                <!-- <v-select
                  dense
                  v-model="periodo"
                  append-icon="mdi-calendar"
                  label="Selecciona un período predeterminado"
                  outlined
                  :items="periodoItems"
                /> -->
                <!-- Quitaría el disabled de este select
                      porque habiendo datos cargados puedes cambiar
                      el rango de fechas en el calendario manualmente
                      así que también se debería poder cambiar 
                      seleccionando períodos en el select  -->
                <!-- :disabled="viendoDatos" -->
              </v-card-text>
              <v-divider></v-divider>
              <v-card-text>
                <v-date-picker
                  v-model="dates"
                  full-width
                  range
                  value="dd-mm-YYYY"
                  :first-day-of-week="1"
                  locale="es-es"
                  no-title
                  show-current
                >
                </v-date-picker>
              </v-card-text>
              <v-divider></v-divider>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  color="primary"
                  class="mr-0"
                  @click="getStats"
                  :loading="loadingForm"
                  >Ver
                  <!-- :disabled="!fechaValida" -->
                  <!-- v-if="!viendoDatos" -->
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-col>
        <v-col
          cols="5"
          sm="6"
          lg="8"
          class="text-right pl-0"
          v-if="showPedidos"
        >
          <div
            class="mt-sm-n2"
            v-if="role == 'admin' || role == 'boss_negocio'"
          >
            <v-btn
              text
              fab
              :small="$vuetify.breakpoint.xs"
              color="rgba(0, 0, 0, 0.54)"
              class="ml-6 ml-sm-4"
              @click="exportarExcel"
              :loading="loadingExportar"
            >
              <div class="d-flex flex-column align-center">
                <v-icon>mdi-file-excel</v-icon>
                <p class="mb-0 text-caption">Exportar</p>
              </div>
            </v-btn>
          </div>
        </v-col>
      </v-row>
      <v-row v-if="role == 'admin'">
        <v-col cols="12">
          <v-row>
            <v-col cols="12" lg="6">
              <v-autocomplete
                dense
                label="Restaurante"
                :items="restaurantesFiltradosTodos"
                v-model="buscarPedido.rest"
              />
            </v-col>
            <v-col cols="12" lg="2">
              <v-text-field
                dense
                label="Número Pedido"
                v-model="buscarPedido.numPedidoRest"
              />
            </v-col>
            <v-col cols="12" lg="2" v-if="false">
              <v-text-field
                disabled
                label="numPedidoRestDia"
                v-model="buscarPedido.numPedidoRestDia"
            /></v-col>
            <v-col cols="12" lg="4">
              <v-btn
                @click="buscarPedidoMetodo"
                color="secondary"
                class="mr-0"
                :loading="loadingForm"
                >Buscar Pedido</v-btn
              ></v-col
            >
          </v-row>
        </v-col>
      </v-row>
      <v-row v-if="role === 'admin'">
        <v-card flat>
          <v-card-title>Búsquedas directas</v-card-title>
          <v-card-text class="mt-4">
            <v-btn
              x-large
              rounded
              outlined
              class="mr-2"
              @click="mostrarPendientesEliminar"
              v-if="role == 'admin'"
            >
              MOSTRAR PENDIENTES ELIMINAR
            </v-btn>
            <v-btn
              x-large
              rounded
              outlined
              class="mr-2"
              @click="mostrarAbonados"
              v-if="role == 'admin'"
            >
              MOSTRAR ABONADOS ONLINE
            </v-btn>
            <v-btn
              x-large
              rounded
              outlined
              @click="contabilizarTodos"
              v-if="role == 'admin'"
            >
              CONTABILIZAR
            </v-btn>
          </v-card-text>
        </v-card>
      </v-row>
      <v-row v-if="showPedidos" justify="center">
        <v-col cols="12" v-if="role == 'admin'">
          <v-expansion-panels popout>
            <v-expansion-panel>
              <v-expansion-panel-header>FILTROS</v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-row justify="center">
                  <v-col cols="12" sm="6">
                    <v-select
                      v-model="filtrosEleccion.formaPago"
                      multiple
                      :items="$store.state.estadisticas.filtros.formaPago"
                      label="Forma Pago"
                    />
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-select
                      v-if="isAdmin"
                      v-model="filtrosEleccion.negocio"
                      :items="$store.state.app.negociosGestArray"
                      @change="reiniciarNegocio"
                      label="Negocio"
                    />
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-select
                      item-value="id"
                      item-text="nombre"
                      v-model="filtrosEleccion.restaurantes"
                      multiple
                      :items="restaurantesFiltrados"
                      label="Restaurante"
                    />
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-select
                      v-model="filtrosEleccion.modo"
                      multiple
                      :items="$store.state.estadisticas.filtros.modo"
                      label="Modo"
                    />
                  </v-col>
                  <v-col cols="6" sm="4">
                    <v-switch
                      v-model="filtrosEleccion.showEliminados"
                      label="Mostrar Eliminados"
                    />
                  </v-col>
                </v-row>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
          <v-expansion-panels popout>
            <v-expansion-panel>
              <v-expansion-panel-header>RESUMEN</v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-row justify="center">
                  <v-col cols="12" sm="4">
                    <base-material-stats-card
                      color="primary"
                      icon="mdi-currency-eur"
                      title="Cantidad"
                      :value="totales.precioTotal"
                      sub-icon="mdi-currency-eur"
                      sub-text="Suma de € en el periodo"
                    />
                  </v-col>
                  <v-col cols="12" sm="4">
                    <base-material-stats-card
                      color="indigo"
                      icon="mdi-store"
                      title="Numero pedidos"
                      :value="totales.numPedidos.toString()"
                      sub-icon="mdi-currency-eur"
                      sub-text="Número de pedidos en el periodo"
                    />
                  </v-col>
                  <v-col cols="12" sm="4">
                    <base-material-stats-card
                      color="secondary"
                      icon="mdi-store"
                      title="Total restaurantes"
                      :value="totales.numRest.toString()"
                      sub-text="Restaurantes en el periodo"
                    />
                  </v-col>
                  <v-col cols="12" sm="6"></v-col>
                </v-row>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>
        <v-col cols="12">
          pedidos
          <listado-pedidos
            :mostrarDiaFecha="true"
            :pedidosBruto="totales.pedidos"
            :datosAdmin="role == 'admin'"
          />
          <!-- <v-data-table
            :headers="headers"
            :items="pedidos"
            :must-sort="true"
            sort-by="fecha"
            :sort-desc="true"
          >
            <template v-slot:item="{ item }">
              <tr :class="item.eliminado ? 'red lighten-2' : ''">
                <td>{{ item.numPedidoRest }}</td>
                <td>{{ item.fechaMostrar }}</td>
                <td>{{ item.modoMostrar }}</td>
                <td>{{ item.formaPagoMostrar }}</td>
                <td>{{ item.precioTotalMostrar }}</td>
                <td>
                  {{ item.copyNegocio.nombre }} - {{ item.copyRest.nombre }}
                </td>
                <td v-if="isAdmin">
                  <v-row>
                    <v-tooltip top v-if="!item.eliminado">
                      <template v-slot:activator="{ on }">
                        <v-btn
                          class="px-2 ml-1"
                          color="red"
                          min-width="0"
                          small
                          :loading="eliminar.loading"
                          v-on="on"
                          @click="openEliminarDialog(item)"
                        >
                          <v-icon class="white--text" small>mdi-delete</v-icon>
                        </v-btn>
                      </template>
                      <span>Eliminar {{ item.id }}</span>
                    </v-tooltip>
                    <v-tooltip top v-else>
                      <template v-slot:activator="{ on }">
                        <div v-on="on">
                          <v-btn
                            class="px-2 ml-1"
                            color="grey"
                            min-width="0"
                            small
                            disabled
                            :loading="eliminar.loading"
                          >
                            <v-icon class="white--text" small
                              >mdi-delete</v-icon
                            >
                          </v-btn>
                        </div>
                      </template>
                      <span>Eliminado: {{ item.eliminadoMotivo }}</span>
                    </v-tooltip>
                    <v-tooltip top v-if="mostrarCurrencyOn(item)">
                      <template v-slot:activator="{ on }">
                        <v-btn
                          class="px-2 ml-1"
                          color="info"
                          min-width="0"
                          small
                          :loading="loadingRefund"
                          v-on="on"
                          @click="refundPedido(item)"
                        >
                          <v-icon small>mdi-currency-eur</v-icon>
                        </v-btn>
                      </template>
                      <span>Devolver Pago</span>
                    </v-tooltip>
                    <v-tooltip top v-if="mostrarCurrencyOff(item)">
                      <template v-slot:activator="{ on }">
                        <v-btn
                          class="px-2 ml-1"
                          color="red"
                          min-width="0"
                          small
                          v-on="on"
                        >
                          <v-icon small>mdi-currency-eur-off</v-icon>
                        </v-btn>
                      </template>
                      <span>El pago se ha devuleto</span>
                    </v-tooltip>
                    <v-tooltip top v-if="item.neoEstado == 'ok'">
                      <template v-slot:activator="{ on }">
                        <div v-on="on">
                          <v-btn
                            class="px-2 ml-1"
                            color="green"
                            min-width="0"
                            small
                            :loading="loadingNeo"
                          >
                            <v-icon class="white--text" small
                              >mdi-alpha-n-circle</v-icon
                            >
                          </v-btn>
                        </div>
                      </template>
                      <v-list dense class="ma-0" shaped>
                        <v-subheader>ESTADO MAPEO NEO</v-subheader>
                        <v-list-item
                          >Fecha intento:
                          {{ item.neoFechaIntento.toDate() }}</v-list-item
                        >
                        <v-list-item
                          >Mensaje: {{ item.neoMensaje }}</v-list-item
                        >
                        <v-list-item>
                          <span class="secondary--text"
                            >ID NEO: {{ item.neoIdPedido }}</span
                          >
                        </v-list-item>
                      </v-list>
                    </v-tooltip>
                    <v-tooltip
                      top
                      v-else-if="item.neoEstado == 'error'"
                      class="pa-0"
                    >
                      <template v-slot:activator="{ on }">
                        <v-btn
                          class="px-2 ml-1"
                          color="red"
                          min-width="0"
                          small
                          :loading="loadingNeo"
                          v-on="on"
                          @click="mapearPedido(item)"
                        >
                          <v-icon class="white--text" small
                            >mdi-alpha-n-circle</v-icon
                          >
                        </v-btn>
                      </template>
                      <v-list dense class="ma-0" shaped>
                        <v-subheader>ESTADO MAPEO NEO</v-subheader>
                        <v-list-item
                          >Fecha intento:
                          {{ item.neoFechaIntento.toDate() }}</v-list-item
                        >
                        <v-list-item
                          >Mensaje: {{ item.neoMensaje }}</v-list-item
                        >
                        <v-list-item class="yellow--text">
                          <span class="secondary--text"
                            >Pulsar para reintentar mapeo</span
                          >
                        </v-list-item>
                      </v-list>
                    </v-tooltip>
                    <v-tooltip top>
                      <template v-slot:activator="{ on }">
                        <v-btn
                          class="px-2 ml-1"
                          color="info"
                          min-width="0"
                          small
                          v-on="on"
                          @click="goView(item)"
                        >
                          <v-icon small>mdi-eye</v-icon>
                        </v-btn>
                      </template>
                      <span>Ver pedido {{ item.id }}</span>
                    </v-tooltip>
                    <imprimirPedido :item="item" />
                  </v-row>
                </td>
              </tr>
            </template>
          </v-data-table> -->
        </v-col>
        <!-- <v-dialog v-model="dialogHistorial" max-width="900">
          <v-card class="mx-auto px-4">
            <v-row justify="center">
              <v-card-title class="mb-4">Historial</v-card-title>
              <v-card-subtitle>Pedido {{ editedItem.id }}</v-card-subtitle>
              <v-card-text>
                <v-expansion-panels>
                  <v-expansion-panel
                    v-for="(h, i) in historialComputed"
                    :key="i"
                  >
                    <v-expansion-panel-header>
                      <v-row no-gutters align="center">
                        <v-col cols="1">
                          <v-chip class="grey white--text">{{
                            historialComputed.length - i
                          }}</v-chip>
                        </v-col>
                        <v-col cols="6">{{
                          h && h.mensaje ? h.mensaje : "sin titulo"
                        }}</v-col>
                        <v-col cols="2" class="text--secondary">{{
                          h && h.usuario ? h.usuario : "sin usuario"
                        }}</v-col>
                        <v-col cols="3" class="text--secondary">{{
                          h && h.fechaMostrar ? h.fechaMostrar : "sin fecha"
                        }}</v-col>
                      </v-row>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>{{
                      h && h.adicional ? h.adicional : "Sin más información"
                    }}</v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
              </v-card-text>
            </v-row>
          </v-card>
        </v-dialog>
        <v-dialog v-model="eliminar.dialogo" width="500">
          <v-card>
            <v-card-title class="headline grey lighten-2 pb-4" primary-title>
              Motivo de la eliminación del pedido
              <h5>{{ eliminar.pedido ? eliminar.pedido.id : "" }}</h5>
            </v-card-title>
            <v-list>
              <v-list-item-group
                v-model="eliminar.motivo"
                mandatory
                color="primary"
              >
                <v-list-item
                  v-for="item in eliminar.motivos"
                  :key="item.value"
                  :value="item.value"
                >
                  <v-list-item-icon>
                    <v-icon v-text="item.icon">{{ item.icon }}</v-icon>
                  </v-list-item-icon>

                  <v-list-item-content>
                    <v-list-item-title v-text="item.text"></v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list-item-group>
            </v-list>

            <v-divider></v-divider>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="primary"
                text
                @click="confirmarEliminar"
                :loading="eliminar.loading"
                >Eliminar</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog> -->
      </v-row>
    </base-material-card>
  </v-container>
</template>

<script>
  import moment from 'moment';
  import { mapState, mapActions, mapGetters } from 'vuex';
  import { mostrarMoneda } from '@/utils/utils.js';
  import imprimirPedido from '@/components/admin/BotonImprimirListadoPedidos';
  import { restSinNegocio } from '@/utils/restaurantes.utils.js';
  import ListadoPedidos from '../../components/ListadoPedidos.vue';

  export default {
    components: {
      imprimirPedido,
      ListadoPedidos,
    },
    data() {
      return {
        accionMostrando: false,
        showPedidosForzar: false,
        buscarPedido: {
          rest: '',
          numPedidoRest: null,
          numPedidoRestDia: null,
        },
        periodo: 'personalizado',
        // showPedidos: false,
        loadingForm: false,
        loadingExportar: false,
        loadingImprimir: false,
        editedItem: {
          historial: [],
        },
        dialogoCalendario: false,
        dialogoAlert: false,
        dialogHistorial: false,
        loadingNeo: false,
        loadingRefund: false,
        tipoItems: [
          {
            value: 'pedidos',
            text: 'Pedidos',
          },
        ],
        filtrosEleccion: {
          formaPago: [],
          showEliminados: false,
          negocio: false,
          restaurantes: [],
          modo: [],
        },
        eliminar: {
          dialogo: false,
          loading: false,
          pedido: null,
          motivos: this.$store.state.pedidos.eliminarMotivos,
          motivo: 'pruebas',
        },
        headersAdmin: [
          {
            sortable: false,
            text: 'Pedido Restaurante',
            value: 'numPedidoRest',
          },
          {
            sortable: false,
            text: 'Fecha',
            value: 'fecha',
          },
          {
            sortable: false,
            text: 'Modo',
            value: 'modo',
          },
          {
            sortable: false,
            text: 'Forma pago',
            value: 'forma_pago',
          },
          {
            sortable: false,
            text: 'Cantidad',
            value: 'precioTotal',
          },
          {
            sortable: false,
            text: 'Restaurante',
            value: 'restaurante',
          },
          {
            sortable: false,
            text: 'Acciones',
            value: 'acciones',
          },
        ],
        headersBossNegocio: [
          {
            sortable: false,
            text: 'Pedido Restaurante',
            value: 'numPedidoRest',
          },
          {
            sortable: false,
            text: 'Fecha',
            value: 'fecha',
          },
          {
            sortable: false,
            text: 'Modo',
            value: 'modo',
          },
          {
            sortable: false,
            text: 'Forma pago',
            value: 'forma_pago',
          },
          {
            sortable: false,
            text: 'Cantidad',
            value: 'precioTotalMostrar',
          },
          {
            sortable: false,
            text: 'Restaurante',
            value: 'restaurante',
          },
        ],

        dates: [],
      };
    },
    computed: {
      showPedidos() {
        console.log(this.totales);
        return (
          (this.totales &&
            this.totales.pedidos &&
            this.totales.pedidos.length > 0) ||
          this.showPedidosForzar
        );
      },

      headers() {
        if (this.isAdmin) {
          return this.headersAdmin;
        } else if (
          this.isBossNegocio ||
          this.isBossRestaurante ||
          this.isBossDirectorio
        ) {
          return this.headersBossNegocio;
        }
      },
      restaurantesFiltradosTodos() {
        return this.$store.state.app.restaurantesArray.map((r) => {
          return {
            text: r.id,
            value: {
              rest: restSinNegocio(r),
              negocio: r.negocio,
            },
          };
        });
      },
      totales() {
        var precioTotalAux = 0;
        const res =
          this.$store.getters['estadisticas/getPedidosListadoHistorial'];
        console.log(res);
        const devolver = res.filter((p) => {
          var bool = true;
          //bool = !p.multipleEsHijo;
          console.log(this.filtrosEleccion);
          if (this.role == 'admin') {
            if (!this.filtrosEleccion.showEliminados) {
              bool = bool && p.eliminado != true;
            }
            if (this.filtrosEleccion.negocio) {
              bool = bool && p.negocio == this.filtrosEleccion.negocio;
            }
            if (this.filtrosEleccion.formaPago.length > 0) {
              bool =
                bool && this.filtrosEleccion.formaPago.includes(p.forma_pago);
            }
            if (this.filtrosEleccion.modo.length > 0) {
              bool = bool && this.filtrosEleccion.modo.includes(p.modo);
            }
            if (this.filtrosEleccion.restaurantes.length > 0) {
              bool =
                bool &&
                this.filtrosEleccion.restaurantes.includes(
                  p.negocio + '-' + p.restaurante
                );
            }
          }
          if (bool) {
            precioTotalAux += parseFloat(p.precioTotal);
          }

          //p.modo =
          return bool;
        });
        console.log(devolver);
        return {
          pedidos: devolver,
          precioTotalMostrar: mostrarMoneda(precioTotalAux),
          numRest:
            this.filtrosEleccion.restaurantes &&
            this.filtrosEleccion.restaurantes.length > 0
              ? this.filtrosEleccion.restaurantes.length
              : this.restaurantesFiltrados
              ? this.restaurantesFiltrados.length
              : 0,
          numPedidos: devolver.length,
        };
        this.precioTotal = mostrarMoneda(precioTotalAux);
        this.numRest =
          this.filtrosEleccion.restaurantes.length > 0
            ? this.filtrosEleccion.restaurantes.length
            : this.restaurantesFiltrados.length;
        this.numPedidos = devolver.length;
        return devolver;
      },
      historialComputed() {
        return this.editedItem.historial
          ? this.editedItem.historial
              .map((h) => {
                return {
                  ...h,
                  fechaMostrar: moment
                    .unix(h.fecha)
                    .format('DD-MM-YYYY HH:mm:ss'),
                };
              })
              .sort((a, b) => {
                return b.fecha - a.fecha - 1;
              })
          : [];
      },
      restaurantesFiltrados() {
        var res;
        if (this.isBossNegocio) {
          res = this.$store.state.restaurantes.restaurantesArray;
        } else if (this.isAdmin) {
          res = this.$store.state.app.restaurantesArray;
        } else if (this.isBossRestaurante) {
          res = this.$store.state.app.restaurantesArray;
        } else if (this.isBossDirectorio)
          res = this.$store.state.app.directorioObjGest.restaurantes;
        return res;
      },
      periodoItems() {
        return [
          { text: 'Personalizado', value: 'personalizado' },
          {
            text: 'La semana pasada',
            value: [
              moment()
                .subtract(1, 'week')
                .startOf('isoWeek')
                .format('YYYY-MM-DD'),
              moment()
                .subtract(1, 'week')
                .endOf('isoWeek')
                .format('YYYY-MM-DD'),
            ],
          },
          {
            text: 'Esta semana',
            value: [
              moment()
                .tz('Europe/Madrid')
                .startOf('isoWeek')
                .format('YYYY-MM-DD'),
              moment().tz('Europe/Madrid').endOf('day').format('YYYY-MM-DD'),
            ],
          },
          {
            text: 'El mes pasado',
            value: [
              moment()
                .subtract(1, 'month')
                .startOf('month')
                .format('YYYY-MM-DD'),
              moment().subtract(1, 'month').endOf('month').format('YYYY-MM-DD'),
            ],
          },
          {
            text: 'Este mes',
            value: [
              moment()
                .tz('Europe/Madrid')
                .startOf('month')
                .format('YYYY-MM-DD'),
              moment().tz('Europe/Madrid').endOf('day').format('YYYY-MM-DD'),
            ],
          },
          {
            text: 'Este año',
            value: [
              moment().startOf('year').format('YYYY-MM-DD'),
              moment().endOf('day').format('YYYY-MM-DD'),
            ],
          },
          {
            text: 'Año pasado',
            value: [
              moment().subtract(1, 'year').startOf('year').format('YYYY-MM-DD'),
              moment().subtract(1, 'year').endOf('year').format('YYYY-MM-DD'),
            ],
          },
        ];
      },
      ...mapGetters({
        role: 'auth/role',
      }),
      ...mapState({
        negocioObj: (state) => state.app.negocioGestObj,
      }),
      rangoFechas() {
        var fechaInicioMoment = moment(String(this.fechaInicio));
        var fechaFinMoment = moment(String(this.fechaFin));
        if (fechaInicioMoment.isAfter(fechaFinMoment)) {
          this.dialogoAlert = true;
          this.fechas = [];
        } else if (fechaInicioMoment.isValid() && fechaFinMoment.isValid()) {
          return (
            fechaInicioMoment.format('DD/MM/YYYY') +
            ' - ' +
            fechaFinMoment.format('DD/MM/YYYY')
          );
        } else {
          return 'Elija fecha';
        }
      },

      tipo: {
        get() {
          return this.$store.state.estadisticas.tipo;
        },
        set(val) {
          this.$store.commit('estadisticas/setTipo', val);
        },
      },
      isAdmin() {
        return this.role == 'admin';
      },
      isBossNegocio() {
        return this.role == 'boss_negocio';
      },
      isBossRestaurante() {
        return this.role == 'boss_restaurante';
      },
      isBossDirectorio() {
        return this.role == 'boss_directorio';
      },
      fechaInicio: {
        get() {
          return this.$store.state.estadisticas.rangoHistorial.inicio;
        },
        set(v) {
          this.$store.commit('estadisticas/setRangoHistorialKey', {
            key: 'inicio',
            value: v,
          });
        },
      },
      fechaFin: {
        get() {
          return this.$store.state.estadisticas.rangoHistorial.fin;
        },
        set(v) {
          this.$store.commit('estadisticas/setRangoHistorialKey', {
            key: 'fin',
            value: v,
          });
        },
      },
    },
    watch: {
      dates(v) {
        if (v.length === 2) {
          this.fechaInicio = v[0];
          this.fechaFin = v[1];
        }
      },
      periodo(v) {
        console.log(v);
        if (v.length === 2) {
          this.dates = v;
        }
      },
    },
    methods: {
      async contabilizarTodos() {
        //migración contable
        console.log(this.totales.pedidos);
        let generar = this.totales.pedidos
          .filter((p) => {
            console.log(p.cobradoDesglose);
            return (
              (!p.cobradoDesglose ||
                p.cobradoDesglose.length == 0 ||
                !p.cobradoDesglose[0].codigoFactura) &&
              !!p.cobrado &&
              !p.eliminado
            );
          })
          .sort((a, b) => a.cobrado - b.cobrado);
        console.log(generar);

        for (let pedido of generar) {
          console.log('pedido');
          console.log(pedido);
          await this.$store.dispatch(
            'contabilidad/contabilizarPedidoAntiguo',
            pedido
          );
        }
        // Promise.all(
        //   generar.map(async (p) => {
        //     await this.$store.dispatch(
        //       "contabilidad/contabilizarPedidoAntiguo",
        //       p
        //     );
        //   })
        // );
      },
      recargar() {
        switch (this.recargar) {
          case 'mostrarAbonados':
            this.mostrarAbonados();
            break;
          case 'mostrarPendientesEliminar':
            this.mostrarPendientesEliminar();
            break;
          case 'buscarPedidoMetodo':
            this.buscarPedidoMetodo();
            break;
          case 'getStats':
            this.getStats();
            break;
        }
      },
      mapearPedido(data) {
        const _vm = this;
        this.$confirm('¿Quiere mapear el pedido?', {
          buttonTrueText: 'Si',
          buttonFalseText: 'No',
          color: 'warning',
          icon: 'warning',
          width: 350,
        })
          .then((res) => {
            if (res) {
              _vm.loadingNeo = true;
              return this.$store.dispatch('pedidos/mapearPedido', data);
            } else {
              return Promise.reject('cancelar');
            }
          })
          .then((r) => {
            const d = r.data;
            if (d.ok) {
              this.$store.commit('snackbar/setMensajeSuccess', {
                msj: 'Pedido mapeado con neo',
              });
            } else {
              this.$store.commit('snackbar/setMensajeDanger', {
                msj: 'Error al mapear con Neo: ' + d.error,
              });
            }
          })
          .catch((e) => {
            if (e != 'cancelar') {
              this.$store.commit('snackbar/setMensajeDanger', {
                msj: 'Error al mapear con Neo: ' + e,
              });
            }
          })
          .finally(() => (_vm.loadingNeo = false));
      },
      refundPedido(data) {
        const _vm = this;
        _vm.loadingRefund = true;
        this.$confirm(
          '¿Desea devolver el dinero? Esta acción es irreversible?',
          {
            buttonTrueText: 'Aceptar',
            buttonFalseText: 'No',
            color: 'warning',
            icon: 'warning',
            width: 350,
          }
        )
          .then((res) => {
            if (res) {
              return this.$store.dispatch('pedidos/refundPedido', data);
            }
          })
          .then((r) => {
            const d = r.data;
            console.log(r);
            if (d.ok) {
              this.$store.commit('snackbar/setMensajeSuccess', {
                msj: 'Reembolso realizado',
              });
            } else {
              this.$store.commit('snackbar/setMensajeDanger', {
                msj: 'Errorr al realizar el reembolso: ' + d.msg,
              });
            }
          })
          .catch((e) => {
            this.$store.commit('snackbar/setMensajeDanger', {
              msj: 'Errorr al realizar el reembolso: ' + e,
            });
          })
          .finally(() => (_vm.loadingRefund = false));
      },
      reiniciarNegocio() {
        this.filtrosEleccion.restaurantes = [];
      },
      mostrarPendientesEliminar() {
        const _vm = this;
        _vm.loadingForm = true;
        this.$store
          .dispatch('pedidos/buscarPedidosSolicitadosEliminacion')
          .then((r) => {
            this.$store.commit('estadisticas/setPedidosHistorial', r);
            this.showPedidosForzar = true;
          })
          .catch((e) => {
            console.log(e);
            _vm.$store.commit('snackbar/setMensajeDanger', {
              msj: 'Error al buscar el pedido ' + e,
            });
          })
          .finally(() => {
            _vm.loadingForm = false;
            this.accionMostrando = 'mostrarPendientesEliminar';
          });
      },
      mostrarAbonados() {
        const _vm = this;
        _vm.loadingForm = true;
        this.$store
          .dispatch('pedidos/mostrarAbonados')
          .then((r) => {
            this.$store.commit('estadisticas/setPedidosHistorial', r);
            this.showPedidosForzar = true;
          })
          .catch((e) => {
            console.log(e);
            _vm.$store.commit('snackbar/setMensajeDanger', {
              msj: 'Error al buscar el pedido ' + e,
            });
          })
          .finally(() => {
            _vm.loadingForm = false;
            this.accionMostrando = 'mostrarAbonados';
          });
      },
      buscarPedidoMetodo() {
        const _vm = this;
        _vm.loadingForm = true;
        this.$store
          .dispatch('pedidos/buscarPedidos', this.buscarPedido)
          .then((r) => {
            console.log(r);
            this.$store.commit('estadisticas/setPedidosHistorial', r);
            this.showPedidosForzar = true;
          })
          .catch((e) => {
            console.log(e);
            _vm.$store.commit('snackbar/setMensajeDanger', {
              msj: 'Error al buscar el pedido ' + e,
            });
          })
          .finally(() => {
            _vm.loadingForm = false;
            this.accionMostrando = 'buscarPedidoMetodo';
          });
      },
      getStats() {
        const _vm = this;
        _vm.loadingForm = true;
        this.$store
          .dispatch('estadisticas/getEstadisticasHistorial')
          .then((r) => {
            /*_vm.$store.commit("snackbar/setMensajeSuccess", {
              msj:
                "Se ha programado el informe, en breve recibirá una mensaje en su centro de notificaciones"
            });*/
            // this.showPedidos = true;
            this.dialogoCalendario = false;
          })
          .catch((e) => {
            console.log(e);
            _vm.$store.commit('snackbar/setMensajeDanger', {
              msj: 'Error al generar el informe ' + e,
            });
          })
          .finally(() => {
            _vm.loadingForm = false;
            this.accionMostrando = 'getStats';
            this.showPedidosForzar = true;
          });
      },
      goView(item) {
        console.log(item);
        let str = '/admin/pedidos/view/' + item.id;
        this.$router.push(str);
      },
      exportarExcel() {
        console.log(this.dates);
        const _vm = this;
        _vm.loadingExportar = true;
        this.$store
          .dispatch('estadisticas/exportarCSV', this.totales.pedidos)
          .then((csvContent) => {
            _vm.$store.commit('snackbar/setMensajeSuccess', {
              msj: 'Informe descargado',
            });
            var encodedUri = encodeURI(csvContent);
            var link = document.createElement('a');
            link.setAttribute('href', encodedUri);
            link.setAttribute(
              'download',
              'informe ' + this.dates[0] + ' - ' + this.dates[1] + '.csv'
            );
            document.body.appendChild(link); // Required for FF
            link.click();
          })
          .catch((e) => {
            console.log(e);
            _vm.$store.commit('snackbar/setMensajeDanger', {
              msj: 'Error al exportar ' + e,
            });
          })
          .finally(() => {
            _vm.loadingExportar = false;
          });
      },
      mostrarCurrencyOn(item) {
        return item.stripeCobrado && item.stripeCobrado != 'refund';
      },
      mostrarCurrencyOff(item) {
        return (
          item.stripeCobrado == 'refund' && item.forma_pago == 'tarjeta_online'
        );
      },
      openEliminarDialog(item) {
        this.eliminar.dialogo = true;
        this.eliminar.pedido = item;
      },
      closeEliminarDialog() {
        this.eliminar.dialogo = false;
        this.eliminar.pedido = null;
        this.eliminar.motivo = 0;
      },
      confirmarEliminar() {
        const _vm = this;
        _vm.eliminar.loading = true;
        _vm.$store
          .dispatch('pedidos/eliminarPedido', {
            idpedido: _vm.eliminar.pedido.id,
            motivo: _vm.eliminar.motivo,
          })
          .then((res) => {
            this.closeEliminarDialog();
            this.getStats();
            this.$store.commit('snackbar/setMensajeSuccess', {
              msj: 'Pedido eliminado',
            });
          })
          .catch((e) => {
            this.$store.commit('snackbar/setMensajeDanger', {
              msj: 'Error al eliminar el pedido: ' + e,
            });
          })
          .finally(() => (_vm.eliminar.loading = false));
      },
      deleteItem(item) {
        let r = confirm('¿Quieres marcar como eliminado el pedido?');
        if (r) {
          this.loading = true;
          let _vm = this;
          this.$store
            .dispatch('pedidos/deletePedido', item)
            .then((res) => {
              _vm.$store.commit('snackbar/setMensajeSuccess', {
                msj: 'Pedido marcado eliminado',
              });
              _vm.getPedidos();
            })
            .catch((error) => {
              _vm.$store.commit('snackbar/setMensajeDanger', {
                msj: 'Error al eliminar: ' + error,
              });
            })
            .finally(() => {
              this.loading = false;
            });
        }
      },
      nuevoRango() {
        // this.showPedidos = false;
        this.$store.commit('estadisticas/setPedidosHistorial', []);
        this.dialogoCalendario = true;
      },
    },

    mounted() {
      let _vm = this;
      if (this.isBossNegocio) {
        this.filtrosEleccion.negocio = this.$store.state.app.negocioGest;
      } else if (this.isBossRestaurante) {
        this.filtrosEleccion.negocio = this.$store.state.app.negocioGest;
        this.filtrosEleccion.restaurante =
          this.$store.state.app.restauranteGest;
      } else if (this.isBossDirectorio) {
        console.log(this.$store.state);
        this.filtrosEleccion.negocio =
          this.$store.state.app.directorioObjGest.negocios;
        this.filtrosEleccion.restaurante =
          this.$store.state.app.directorioObjGest.restaurantes;
      }
      this.recargar();
    },
  };
</script>

<style></style>
